// Configured brand-protection keywords the infostealers widgets care about:
// the union of the platform + api keywordsBySource buckets and the legacy
// keywordsList (still supported). API-hub keywords are included so API-initiated
// brand protection reflects in the UI like platform keywords. The cyn-ai bucket
// is never included — it is owned by the agents hub, not the platform tenant.
export function configuredKeywords(brandProtection) {
  const bp = brandProtection || {};
  const set = new Set();
  (bp.keywordsBySource?.platform || []).forEach(e => set.add(typeof e === 'string' ? e : e.keyword));
  (bp.keywordsBySource?.api || []).forEach(e => set.add(typeof e === 'string' ? e : e.keyword));
  (bp.keywordsList || []).forEach(k => set.add(k));
  return set;
}

export function calculateProgressValue(job) {
  if (job.status === 'done') {
    return 100;
  }
  if (job.status === 'error') {
    return 0;
  }

  let progress = 0;
  if (job.phase === 'search_phase') {
    progress = Math.round(job.search_progress * 0.4);
  } else if (job.phase === 'processing_results') {
    progress = Math.round(40 + (job.processing_progress * 0.6));
  }

  return progress;
}

export function calculateProgressPercentage(job) {
  if (job.status === 'done') {
    return '100%';
  }
  if (job.status === 'error') {
    return '0%';
  }

  let progress = 0;
  if (job.phase === 'search_phase') {
    progress = Math.round(job.search_progress * 0.4);
  } else if (job.phase === 'processing_results') {
    progress = Math.round(40 + (job.processing_progress * 0.6));
  }

  return `${progress}%`;
}

export function calculateState(job) {
  if (job.status === 'done') {
    return 'Done';
  }
  if (job.status === 'error') {
    return 'Error';
  }

  if (job.phase === 'search_phase') {
    return 'Searching';
  } if (job.phase === 'processing_results') {
    return 'Processing';
  }
  return 'Starting';
}

export function calculateAmount(job) {
  if (job.status === 'done') {
    return 'Done';
  }
  if (job.status === 'error') {
    return 'Error';
  }

  if (job.phase === 'search_phase') {
    const searchProgress = parseFloat(job.search_progress).toFixed(2);
    return `${searchProgress}%`;
  } if (job.phase === 'processing_results') {
    const processed = job.processed_results || 0;
    const total = job.total_results || 0;
    return `${processed}/${total}`;
  }
  return 'Starting...';
}

export function calculateProgressColor(job) {
  const progressValue = calculateProgressValue(job);
  return progressValue === 100 ? '#2459D5' : '#56C228';
}
